<script>
  export let action;
  export let host;

  import { createEventDispatcher } from "svelte";
  import { createAction } from "../lib/wirus-integration";

  const dispatch = createEventDispatcher();

  const onOverlayClickHandler = () => {
    dispatch("destroy");
  };

  $: dialogStep = "confirm";
  $: receivedPoints = undefined;

  const showCompleteDialog = points => {
    dialogStep = "completed";
    receivedPoints = points;
    setTimeout(() => {
      dispatch("destroy");
    }, 2000);
  };

  const completeAction = () => {
    createAction(action)
      .then(() => showCompleteDialog(action.points))
      .catch(err => {
        console.log(err);
      });
  };

  const startAction = () => {
    createAction(action)
      .catch(err => {
        console.log(err);
      })
      .then(() => dispatch("destroy"));
  }

  const signupAction = () => {
    createAction({...action, host})
      .then(() => showCompleteDialog())
      .catch(err => {
        console.log(err);
      });
  };
</script>

<style>
  .dialog-wrapper {
    position: absolute;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 20px;
    box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.2);
    padding: 40px;
    display: flex;
    flex-flow: column;
    align-items: center;
    max-width: 280px;
  }

  .action-tag {
    background: #ff8811;
    color: white;
    font-weight: 500;
    border-radius: 20px;
    padding: 3px 10px;
    font-size: 14px;
  }

  .action-title {
    font-weight: 600;
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 5px;
    text-align: center;
  }

  .action-desc {
    font-size: 14px;
    text-align: center;
    margin-bottom: 30px;
  }

  .action-hint {
    text-align: center;
    font-size: 12px;
    padding-top: 30px;
  }

  .overlay {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: black;
    opacity: 0.1;
  }

  .received-points-wrapper {
    font-size: 15px;
    margin-top: 25px;
  }
  .received-points-wrapper i {
    font-size: 12px;
  }
</style>

<div class="overlay" on:click={onOverlayClickHandler} />

<div class="dialog-wrapper">
  {#if dialogStep == 'confirm'}
    <div class="action-tag">Action</div>
    <div class="action-title">{action.title}</div>
    <div class="action-desc">{action.description}</div>

    {#if action.isCompleted && !action.isConfirmable}
      <button on:click={completeAction}>Jetzt helfen</button>
      <span class="action-hint">Du erhälst sofort punkte.</span>
    {:else if !action.isConfirmable}
      <button on:click={startAction}>Starten</button>
      <span class="action-hint">Du erhälst punkte, sobald du die Aktion abgeschlossen hast.</span>
    {:else}
      <button on:click={signupAction}>Eintragen</button>
      <span class="action-hint">
        Du erhälst punkte, sobald dein Host <em>{host}</em>
        dies bestätigt hat. Du kannst die Bestätigung über die App anfragen.
      </span>
    {/if}
  {:else if dialogStep == 'completed'}
    <i class="far fa-check-circle fa-3x" style="color: #00a676" />
    {#if receivedPoints}
      <div class="received-points-wrapper">
        <i class="em em-tada" />
        <span style="padding: 0 8px">+{receivedPoints} points</span>
        <i class="em em-tada" />
      </div>
    {/if}
  {/if}
</div>
